import { render, staticRenderFns } from "./seeClassMinsCtr.vue?vue&type=template&id=6a80b552&scoped=true"
import script from "./seeClassMinsCtr.vue?vue&type=script&lang=js"
export * from "./seeClassMinsCtr.vue?vue&type=script&lang=js"
import style0 from "./seeClassMinsCtr.vue?vue&type=style&index=0&id=6a80b552&prod&lang=less"
import style1 from "./seeClassMinsCtr.vue?vue&type=style&index=1&id=6a80b552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80b552",
  null
  
)

export default component.exports